import React from 'react'

import styled from '@emotion/styled'
import { mq } from '../../_style'
import Image from '../atoms/image';

const Container = styled.div`
  ${mq.pc} {
    width: ${props => props.flexibleBase ? `${props.pcWidth / props.flexibleBase * 100}%` : `${props.pcWidth}px`};
    min-width: ${props => `${props.pcWidth}px`};
    display: ${props => props.spOnly ? 'none' : 'block' };
  }
  ${mq.pcMin} {
    min-width: ${props => props.flexibleBase ? `${props.pcWidth * 0.7}px` : `${props.pcWidth}px`};
  }
  ${mq.sp} {
    width: ${props => props.spWidth}px;
    min-width: ${props => props.spWidth}px;
    margin: ${props => props.spOnly ? 'auto auto 20px' : 'auto'};
    display: ${props => props.pcOnly ? 'none' : 'block' };
  }
`
export default class SizedImage extends React.Component {
  render() {
    return(
      <Container pcOnly={this.props.pcOnly} spOnly={this.props.spOnly} pcWidth={this.props.pcWidth} spWidth={this.props.spWidth} flexibleBase={this.props.flexibleBase}>
        <Image filename={this.props.filename} alt={this.props.alt}></Image>
      </Container>
    )
  }
}
